import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["status", "testId", "overrideUrl"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { SmartLinkStatus } from '../../../../../constants';
import PreviewBlockResolvedView from './resolved/indexOld';
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */
var PreviewBlock = function PreviewBlock(_ref) {
  var _ref$status = _ref.status,
    status = _ref$status === void 0 ? SmartLinkStatus.Fallback : _ref$status,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-block-preview' : _ref$testId,
    overrideUrl = _ref.overrideUrl,
    blockProps = _objectWithoutProperties(_ref, _excluded);
  return jsx(PreviewBlockResolvedView, _extends({}, blockProps, {
    testId: testId,
    overrideUrl: overrideUrl
  }));
};
export default PreviewBlock;